module.exports = __webpack_public_path__ + "img/ruoyi12.af6d114e.png";